export var GrantedPermissionApi;
(function (GrantedPermissionApi) {
    GrantedPermissionApi["VIEW_USER_PERSONAL_DETAILS"] = "view_user_personal_details";
    GrantedPermissionApi["VIEW_ALL_PROJECTS"] = "view_all_projects";
    GrantedPermissionApi["VIEW_PROJECT_MILESTONES"] = "view_project_milestones";
    GrantedPermissionApi["VIEW_PROJECT_THREADS"] = "view_project_threads";
    GrantedPermissionApi["VIEW_PROJECT_ATTACHMENTS"] = "view_project_attachments";
    GrantedPermissionApi["VIEW_PROJECT_NDA_DETAILS"] = "view_project_nda_details";
    GrantedPermissionApi["VIEW_MARKETPLACE_STATS"] = "view_marketplace_stats";
    GrantedPermissionApi["VIEW_PRIVATE_BIDS"] = "view_private_bids";
    GrantedPermissionApi["CREATE_PROJECT_COLLABORATION"] = "create_project_collaboration";
    GrantedPermissionApi["VIEW_SUPPORT_SESSIONS"] = "view_support_sessions";
    GrantedPermissionApi["CLOSE_USER"] = "close_user";
    GrantedPermissionApi["MANAGE_INSOURCE_ROLES"] = "manage_insource_roles";
    GrantedPermissionApi["VIEW_ANALYTICS"] = "view_analytics";
    GrantedPermissionApi["UPDATE_ENTERPRISE"] = "update_enterprise";
    GrantedPermissionApi["MANAGE_ENTERPRISE_PAYMENTS"] = "manage_enterprise_payments";
    GrantedPermissionApi["MANAGE_LOADSHIFT_MEMBERSHIP"] = "manage_loadshift_membership";
    GrantedPermissionApi["UPDATE_ENTERPRISE_PROJECT"] = "update_enterprise_project";
    GrantedPermissionApi["CREATE_TASK_SECTION"] = "create_task_section";
    GrantedPermissionApi["MANAGE_EMAIL_CONTENT"] = "manage_email_content";
    GrantedPermissionApi["VIEW_TASKS"] = "view_tasks";
    GrantedPermissionApi["CREATE_ENTERPRISE_BIDS"] = "create_enterprise_bids";
    GrantedPermissionApi["REOPEN_PROJECT"] = "reopen_project";
    GrantedPermissionApi["MANAGE_GROUPS"] = "manage_groups";
    GrantedPermissionApi["MANAGE_BANNERS"] = "manage_banners";
    GrantedPermissionApi["MANAGE_PROJECT_NOTES"] = "manage_project_notes";
    GrantedPermissionApi["SEARCH_USERS_BY_EMAIL"] = "search_users_by_email";
})(GrantedPermissionApi || (GrantedPermissionApi = {}));
